firebird.factory('videoDeviceService', [
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'helperService',
    'avDeviceService',
    'storageService',
    'supportLinkService',
    'brandingService',
    'localizationService',
    'videoGlobalService',
    'localStreamManagerService',
    'socketService',
    'executionEnvironmentEnum',
    function (
        $window,
        logService,
        attendeeService,
        connectivityService,
        helperService,
        avDeviceService,
        storageService,
        supportLinkService,
        brandingService,
        localizationService,
        videoGlobalService,
        localStreamManagerService,
        socketService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoDeviceService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.getDeviceTimeoutSwalOptions = getDeviceTimeoutSwalOptions;

            self.showDeviceInUseAlert = showDeviceInUseAlert;

            self.selectedVideoInput = null;
            self.selectedAudioInput = null;

            self.updateLocalAudioState = updateLocalAudioState;

            // willSwitchDevice + avDeviceService.setIsMicrophoneDeviceSwitching are used for prevent appearing red exclamation mark when switching microphone
            self.willSwitchDevice = false;
            self.onFinishedMediaDeviceSelection = onFinishedMediaDeviceSelection;
            self.onFinishedAudioDeviceConnect = onFinishedAudioDeviceConnect;
            self.updateAudioInputDevice = updateAudioInputDevice;
            self.updateAudioOutputDevice = updateAudioOutputDevice;

            self.reconnectAudioInput = reconnectAudioInput;
            self.deviceUpdateEventToMsgFlow = deviceUpdateEventToMsgFlow;

            // when audio video state is updated in node server
            $scope.$on('update-local-audio-state', updateLocalAudioState);
            $scope.$on('update-local-video-state', updateLocalVideoState);

            // device selection and permission
            $scope.$on('finished-media-device-selection', onFinishedMediaDeviceSelection);

            $scope.$on('sfu-audio-device-reconnection', onFinishedAudioDeviceConnect);
            $scope.$on('sfu-video-device-reconnection', onFinishedVideoDeviceConnect);

            $scope.$on('phone-state-updated', onPhoneStateUpdated);

            $scope.$on('update-audio-output', self.updateAudioOutputDevice);
            $scope.$on('reconnect-audio-input', self.reconnectAudioInput);
        }

        function getDeviceTimeoutSwalOptions() {
            var supportLink = supportLinkService.getSupportLink('manageDevices');
            var title = localizationService.translate(
                'HEADER.PERMISSIONS_ERROR.COMMON.PROBLEM_ACCESSING_DEVICE_HEADER'
            );
            var msg = localizationService.translate('HEADER.PERMISSIONS_ERROR.COMMON.PROBLEM_ACCESSING_DEVICE', {
                link: supportLink
            });
            var confirmBtnText = localizationService.translate('COMMON.OKAY_TEXT');
            var swalOptions;
            var closeButtonHtmlDeviceAccessProblem =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            swalOptions = {
                title: closeButtonHtmlDeviceAccessProblem + title,
                text: msg,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: confirmBtnText,
                confirmButtonColor: brandingService.getBaseColor(),
                allowOutsideClick: false,
                html: true,
                imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
            };

            return swalOptions;
        }

        function showDeviceInUseAlert(device) {
            var alert;
            switch (device) {
                case 'microphone':
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_MICROPHONE');
                    break;
                case 'webcam':
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM');
                    break;
                case 'microphone and webcam':
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_MICROPHONE_WEBCAM');
                    break;
                default:
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM');
            }
            self.showAlert(alert, localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_HOW_TO_FIX'));
        }

        function updateLocalAudioState() {
            var currentLocalTrack;
            // for mediapath of 'sfu' use video stream (videoroom plugin), otherwise use audio stream (SIP plugin).
            var mystream = self.mediapath == 'sfu' ? self.mystream : self.mystream1;
            if (mystream && mystream.getAudioTracks() && mystream.getAudioTracks()[0]) {
                currentLocalTrack = mystream.getAudioTracks()[0];
            }

            self.updateConnTimeDevice();

            if (connectivityService.getAudioThroughPhone() || avDeviceService.isAudioDisconnected()) {
                if (mystream && currentLocalTrack && currentLocalTrack.readyState === 'live') {
                    logService.log('videoroomCtrl switched-to-phone, stopping audio track');
                    if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                        // On Citrix, cloning stream before stop so that the attendee is able to join the meeting even if no active stream is present.
                        var clonedStream = mystream.clone();
                        if (clonedStream && clonedStream.getAudioTracks() && clonedStream.getAudioTracks()[0]) {
                            clonedStream.getAudioTracks()[0].enabled = false;
                        }
                    }
                    mystream.getAudioTracks()[0].stop();
                }

                // this flag is used for audioEnabled or not, beyond just CDR.
                self.cdrAudioEnabled = false;
                return;
            }

            if (currentLocalTrack && currentLocalTrack.readyState === 'ended') {
                //Sometimes when switched to phone, when unplugging an audio device,
                //storageService will still keep reference to that unplugged device's id
                //
                //calling determineMicAndCamAvailability will check the current devices to keep storageService up-to-date

                logService.log('videoroomCtrl switched-to-mic, checking device availability');
                avDeviceService
                    .determineMicAndCamAvailability()
                    .catch(function (err) {
                        logger.error('updateLocalAudioState', 'switched-to-mic error', err);
                    })
                    .finally(function () {
                        logService.log('videoroomCtrl switched-to-mic, updating audio input device');
                        self.updateAudioInputDevice('switch-to-mic audio-change');
                    });
            }

            var enable = !attendeeService.getIsAudioMuted();
            logService.log('videoroomCtrl update local audio state: ' + (enable ? 'unmuted' : 'muted'));

            // since audio is published via the SIP plugin.
            try {
                if (mystream) {
                    mystream.getAudioTracks()[0].enabled = enable;
                } else {
                    logger.warn(
                        'updateLocalAudioState',
                        'cannot change audio track enabled because mystream was not set'
                    );
                }
            } catch (e) {
                logger.warn('updateLocalAudioState', 'failed to change audio track enabled', e);
            }

            self.cdrAudioEnabled = enable;
            self.cdrAudioChanged = true;
        }

        function updateLocalVideoState() {
            var enable = attendeeService.getIsVideoMuted() ? false : true;
            logService.log('videoroomCtrl update local video state: ' + (enable ? 'unvmuted' : 'vmuted'));

            // since video is published via the video room plugin.
            try {
                // if video feed is stopped, then no video track present.
                self.mystream.getVideoTracks()[0].enabled = enable;
                if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                    // Required to stop webcam light when webcam stream is turned off
                    self.mystream.getVideoTracks()[0].stop();
                }
            } catch (e) {}
        }

        function onFinishedAudioDeviceConnect(e, data) {
            logService.log('videoroomCtrl onFinishedAudioDeviceConnect...', data);

            self.updateAudioOutputDevice();
            self.updateAudioInputDevice('deviceReconnect audio-change');
        }

        function onFinishedVideoDeviceConnect(e, data) {
            //This function is specifically called as part of the device reconnection flow logic
            // as such, it doesn't check the muted state because that will be reset by the calls below.
            // This allows us active fallback to an available camera
            logService.log('videoroomCtrl onFinishedVideoDeviceConnect...', data);

            self.setInitialBitrate();

            self.stopVideoPublish();
            self.startVideoPublish();
        }

        //the event that triggers this essentially means the mic webcam options dialog has closed
        function onFinishedMediaDeviceSelection(e, data) {
            logService.log('videoroomCtrl onFinishedMediaDeviceSelection...', data);

            if (data && data.usePhoneForAudio !== undefined) {
                logService.log('videoroomCtrl Setting new audioThroughPhone value:', data.usePhoneForAudio);
                connectivityService.setAudioThroughPhone(data.usePhoneForAudio, true);
            }

            if (avDeviceService.isAudioDisconnected()) {
                connectivityService.disconnectAudioInputAndOutput(true);
            }

            if (data && data.newAudioOutputDeviceSelected) {
                self.updateAudioOutputDevice();
            }

            self.setInitialBitrate();

            // ANYAM-72965: webcam was unplugged and then plugged in and selected in AM settings
            // need to rejoin conference to see webcam in recording
            // Note: video is muted when new webcam connected
            let rejoiningConference = false;
            if (avDeviceService.getIsNewVideoDeviceConnected()) {
                logger.log('onFinishedMediaDeviceSelection', 'Webcam connected, rejoin the meeting');
                avDeviceService.setIsNewVideoDeviceConnected(false);

                if (!data || !data.joinMeeting) {
                    rejoiningConference = true;
                    self.rejoinConferenceIfNeeded('Webcam connected');
                }
            }

            if (data && (data.newVideoInputDeviceSelected || data.newAudioInputDeviceSelected)) {
                self.deviceUpdateEventToMsgFlow('device-select', {
                    audio: data.newAudioInputDeviceSelected,
                    video: data.newVideoInputDeviceSelected
                });
                if (!rejoiningConference && data.newVideoInputDeviceSelected && !attendeeService.getIsVideoMuted()) {
                    // //TODO: following is better but does not work in removing/adding
                    // //video track when simulcast is enabled. see related issue ANYAM-13288
                    // var mediaVideo = self.getMediaConstraints('video');
                    // mediaVideo.replaceVideo = true;
                    // self.videoroom.createOffer({
                    //     media: mediaVideo,
                    //     simulcast: self.simulcast,
                    //     success: function(jsep) {
                    //         logService.log('videoroomCtrl videoroom got publisher SDP!');
                    //         logService.log(jsep);
                    //         var publish = { 'request': 'configure', 'audio': true, 'video': true, 'bitrate': self.getVideoBitrate() };
                    //         self.videoroom.send({'message': publish, 'jsep': jsep});
                    //     },
                    //     error: function(error) {
                    //         logger.error('onFinishedMediaDeviceSelection', 'videoroom publisher WebRTC error', error);
                    //     }
                    // });

                    // Instead remove and add the videoroom participant.
                    self.stopVideoPublish();
                    self.startVideoPublish();
                }

                if (data.newAudioInputDeviceSelected) {
                    self.updateAudioInputDevice('audio-change');
                    //If mic changes, running enumerateDevices is needed to
                    //iterate through the device list and make sure the proper BT Audio Output is selected
                    avDeviceService.enumerateDevices();
                }
            } else if (data && data.joinMeeting) {
                logService.log('videoroomCtrl joining meeting from initial device selection modal');
                self.joinConference();
            }
        }

        function updateAudioInputDevice(reason) {
            if (self.sipcall) {
                // last parameter is either reason string or true.
                self.msgflowEvent('peer-connection:device', {
                    type: 'audio',
                    reason: reason || 'audio input device change'
                });

                var deviceChange = reason || true;

                if (reason === 'audio-change') {
                    self.willSwitchDevice = true;
                }

                if (self.mediapath == 'sfu') {
                    self.createOfferOrRepublish(
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        deviceChange ? 'audio-change' : 'audio'
                    );
                } else {
                    self.createOfferForSIP(false, false, deviceChange);
                }
            } else {
                logService.log('videoroomCtrl ignoring updateAudioInputDevice, as no sip call');
            }
        }

        // Update the sink of the audio element based on the stored audio-output-device id.
        // Note: after calling setSinkId on a specific media element every other media element also started to use the same device for output.
        // This is why changing the audio output device works even for the mediapath 'sfu'.
        // https://stackoverflow.com/questions/48318007/setsinkid-change-muliple-audio-ouputs/48329464#48329464
        function updateAudioOutputDevice() {
            try {
                logService.log('videoroomCtrl updateAudioOutputDevice');

                var audioElement = $window.$('#videoroom-sipaudio')[0];
                logService.log('videoroomCtrl updateAudioOutputDevice: sinkId before=' + audioElement.sinkId);

                //Clear sinkId before setting new val
                audioElement
                    .setSinkId('')
                    .catch(function (err) {
                        logger.error('updateAudioOutputDevice', 'Error clearing sinkid', err);
                    })
                    .finally(function () {
                        var audioOutputDeviceId = storageService.get('audio-output-device');
                        if (audioOutputDeviceId) {
                            logService.log('videoroomCtrl updateAudioOutputDevice: ', audioOutputDeviceId);
                            audioElement
                                .setSinkId(audioOutputDeviceId)
                                .catch(function (err) {
                                    logger.error(
                                        'updateAudioOutputDevice',
                                        'Error set sinkid',
                                        audioOutputDeviceId,
                                        err
                                    );
                                })
                                .finally(function () {
                                    logService.log(
                                        'videoroomCtrl updateAudioOutputDevice: sinkId after=' + audioElement.sinkId
                                    );
                                });
                            // crossbrowser compatibility check.
                            // firefox requires users to explicitly enable this feature in about:config media.setsinkid.enabled
                        } else {
                            logService.log('videoroomCtrl updateAudioOutputDevice: no audioOutputDeviceId');
                        }
                    });
            } catch (err) {
                logService.log('videoroomCtrl Unable to set sink Id: ', err);
            }
            if (self.VDIRef?.getVdiType() === executionEnvironmentEnum.Citrix) {
                // From Citrix sdk v2.0, the audio stream is not auto-played when srcObject is set. Audioelement.play() needs to be called.
                logService.log('videoroomCtrl audioElement: play');
                audioElement.play();
            }
        }

        function reconnectAudioInput() {
            logService.log('videoroomCtrl reconnectAudioInput');
            self.updateAudioInputDevice('deviceReconnect audio-change reconnect-after-device-error');
        }

        function onPhoneStateUpdated() {
            self.updateLocalAudioState();
        }

        // audio and video are either true/false or an object with trackId
        function deviceUpdateEventToMsgFlow(event, { audio, video }) {
            const deviceInfo = {};
            if (audio) {
                let deviceId = storageService.get('audio-device');
                deviceInfo.audio = {
                    ...audio,
                    deviceId: deviceId,
                    label: avDeviceService.getLabelForDeviceId(deviceId, 'audioinput')
                };
            }
            if (video) {
                let deviceId = storageService.get('video-device');
                deviceInfo.video = {
                    ...video,
                    deviceId: deviceId,
                    label: avDeviceService.getLabelForDeviceId(deviceId, 'videoinput')
                };
            }
            self.msgflowEvent(event, deviceInfo);
            logger.log('deviceUpdateEventToMsgflow', event, deviceInfo);
        }
    }
]);
